import { render, staticRenderFns } from "./TutorialButton.vue?vue&type=template&id=bc7e928e&lang=pug&"
import script from "./TutorialButton.vue?vue&type=script&lang=js&"
export * from "./TutorialButton.vue?vue&type=script&lang=js&"
import style0 from "./TutorialButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports